export interface EntryData {
    'id': number;
    '@id': string;
    'form': string;
    'firstName': string;
    'lastName': string;
    'email': string;
    'accessCode': string;
    'status': string;
    'readableStatus': string;
    'data': any;
    'started': number;
    'updated': number;
}

export class Entry {
    id: number;
    uri: string;
    form: string;
    firstName: string;
    lastName: string;
    email: string;
    accessCode: string;
    status: string;
    readableStatus: string;
    data: any;
    answerCount: number;
    started: number;
    updated: number;

    constructor(data: EntryData) {
        this.id = data.id;
        this.uri = data['@id'];
        this.form = data.form;
        this.firstName = data.firstName || '';
        this.lastName = data.lastName || '';
        this.email = data.email || '';
        this.accessCode = data.accessCode;
        this.status = data.status;
        this.readableStatus = data.readableStatus;
        this.data = data.data;
        this.started = data.started;
        this.updated = data.updated;
        this.answerCount = data.data ? Object.keys(data.data).length : 0;
    }
}
